import React, { useRef, useState } from 'react';
import * as classNames from 'classnames';
import Dropdown from '../Dropdown/Dropdown';
import './TooltipStyles.scss';

export default function TooltipWithPortal(props) {
  const {
    content = '',
    tooltipContent = '',
    className = '',
    classNameWrapper = '',
    classNamePortal = '',
    classNameDropdown = '',
    showByClick = false,
  } = props;
  const [isOpen, setOpen] = useState(false);
  const anchorElement = useRef(null);
  // let timeout = null;
  let useProps = {
    onMouseEnter: () => setOpen(true),
    onMouseLeave: () => setOpen(false),
    // onMouseEnter: () => { timeout = setTimeout(() => { setOpen(true); }, 300); },
    // onMouseLeave: () => { if (isOpen) { setOpen(false); } else { clearTimeout(timeout); } },
  };
  if (showByClick) {
    useProps = {
      onClick: event => {
        setOpen(true);
      },
    };
  }
  return (
    <Dropdown
      usePortal
      customControl
      customOpen={isOpen}
      customHandleClose={() => { setOpen(false); }}
      className={classNames('tooltip-dropdown', classNameDropdown)}
    >
      <Dropdown.Toggle>
        <div
          className={classNames('portal-tooltip', className)}
          ref={anchorElement}
        >
          <div className="tooltip-content" {...useProps}>
            {content}
            <div className="field-click-ext" />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={classNames('portal-tooltip-wrapper', classNameWrapper)}
        anchorElement={anchorElement}
        classNamePortal={classNames('portal-tooltip', classNamePortal)}
        {...useProps}
        useResizeContent={false}
      >
        <div
          className="portal-tooltip-popup"
        >
          {tooltipContent || content}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
